module.exports = __webpack_public_path__ + "img/ReederP13BlueMaxLite.63a41121.png";